<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <div v-if="getSignedInUser" class="dashboard-summary">
          <v-layout row wrap>
            <v-flex xs12>
              <div class="d-flex align-center justify-space-between mb-3">
                <h1>Dashboard Summary</h1>
                <v-btn color="primary" :to="{ name: 'dashboard-reports' }">
                  View All Reports
                </v-btn>
              </div>
            </v-flex>

            <v-flex xs12 v-if="summaryLoading">
              <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-flex>

            <v-flex xs12 class="mb-3">
              <h2>Top Vehicles - Ticket Revenue</h2>
              <div><small>The top 5 vehicles by ticket revenue for the selected period.</small></div>
            </v-flex>

            <v-flex xs12 sm6 md3 v-for="card in ticketRevenueSummaryCards" :key="'ticket-revenue-' + card.key">
              <v-card class="ma-2">
                <v-card-title primary-title>
                  <div>
                    <h3>{{ card.title }}</h3>
                    <div class="mt-2" v-if="!card.hasData">No data available</div>
                  </div>
                </v-card-title>
                <v-card-text v-if="card.hasData">
                  <apexchart
                    type="bar"
                    height="180"
                    :options="revenueChartOptions(card)"
                    :series="card.series"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 class="mt-4 mb-3">
              <h2>Top Vehicles - Distance Travelled</h2>
              <div><small>The top 5 vehicles by distance travelled for the selected period.</small></div>
            </v-flex>

            <v-flex xs12 sm6 md3 v-for="card in summaryCards" :key="card.key">
              <v-card class="ma-2">
                <v-card-title primary-title>
                  <div>
                    <h3>{{ card.title }}</h3>
                    <div class="mt-2" v-if="!card.hasData">No data available</div>
                  </div>
                </v-card-title>
                <v-card-text v-if="card.hasData" class="distance-ranking-row">
                  <div
                    v-for="(vehicle, index) in card.rankedVehicles"
                    :key="card.key + '-' + vehicle.vehicleId"
                    class="distance-ranking-item"
                    :class="'rank-' + (index + 1)"
                  >
                    <div class="distance-ranking-distance">{{ vehicle.distanceLabel }}</div>
                    <div class="distance-ranking-license">{{ vehicle.vehicleLabel }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </div>

        <div v-else-if="getSignedInUser === undefined" style="text-align: center">
          <img src="@/assets/logo.png" style="width: 350px;" alt="SmartTransit" class="mb-5">
        </div>

        <div style="width: 400px" v-else-if="getSignedInUser === null">
          <sign-in-form :after-login="afterLoginForward"></sign-in-form>
        </div>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dashboard-summary {
  width: 100%;
}

.distance-ranking-row {
  overflow: hidden;
  padding-bottom: 8px;
}

.distance-ranking-item {
  flex: 1 1 0;
  min-width: 0;
  margin-bottom: 12px;
}

.distance-ranking-distance {
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.distance-ranking-license {
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.68);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.distance-ranking-item.rank-1 .distance-ranking-distance {
  font-size: 1.95rem;
}

.distance-ranking-item.rank-2 .distance-ranking-distance {
  font-size: 1.65rem;
}

.distance-ranking-item.rank-3 .distance-ranking-distance {
  font-size: 1.4rem;
}

.distance-ranking-item.rank-4 .distance-ranking-distance {
  font-size: 1.2rem;
}

.distance-ranking-item.rank-5 .distance-ranking-distance {
  font-size: 1.05rem;
}

.distance-ranking-item.rank-1 .distance-ranking-license {
  font-size: 0.95rem;
}

.distance-ranking-item.rank-2 .distance-ranking-license {
  font-size: 0.88rem;
}

.distance-ranking-item.rank-3 .distance-ranking-license {
  font-size: 0.82rem;
}

.distance-ranking-item.rank-4 .distance-ranking-license {
  font-size: 0.78rem;
}

.distance-ranking-item.rank-5 .distance-ranking-license {
  font-size: 0.74rem;
}
</style>

<script>
import src from './src'
export default src
</script>
